export default {
  user: {},
}



// WEBPACK FOOTER //
// ./src/pages/auth/store/state.js